/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import FormInput from './FormInput';

function ContactForm({ title, heading }) {
    const [message, setMessage] = useState('');
    const [file, setFile] = useState(null);

    const onChangeHandler = (e) => {
        setMessage(e.target.value);
    };

    const onFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const onSubmitHandler = (e) => {
        e.preventDefault();

        // You can handle form data here
        console.log({
            message,
            file,
        });
    };

    return (
        <section className="contact-form-wrapper section-padding pt-0">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center mb-20">
                        <span>{title}</span>
                        <h1>{heading}</h1>
                    </div>

                    <div className="col-12 col-lg-12">
                        <div className="contact-form">
                            <form className="row contact-form" onSubmit={onSubmitHandler}>
                                
                                {/* Name */}
                                <FormInput
                                    type="text"
                                    labelFor="fullname"
                                    label="Name"
                                    placeholder="Enter Name"
                                    id="fullname"
                                    gridClass="col-md-6 col-12"
                                    required
                                />

                                {/* Email */}
                                <FormInput
                                    type="email"
                                    labelFor="email"
                                    label="Email"
                                    placeholder="Enter Email Address"
                                    id="email"
                                    gridClass="col-md-6 col-12"
                                    required
                                />

                                {/* Phone */}
                                <FormInput
                                    type="tel"
                                    labelFor="phone"
                                    label="Phone Number"
                                    placeholder="Enter Phone Number"
                                    id="phone"
                                    gridClass="col-md-6 col-12"
                                    required
                                />

                                {/* Company Name */}
                                <FormInput
                                    type="text"
                                    labelFor="company"
                                    label="Company Name (Optional)"
                                    placeholder="Enter Company Name"
                                    id="company"
                                    gridClass="col-md-6 col-12"
                                />
                                                                
                                {/* Subject */}
                                <FormInput
                                    type="text"
                                    labelFor="subject"
                                    label="Subject (Optional)"
                                    placeholder="Enter Subject"
                                    id="subject"
                                    gridClass="col-md-12 col-12"
                                />

                                {/* Message */}
                                <div className="col-md-12 col-12">
                                    <div className="single-personal-info">
                                        <label htmlFor="message">
                                            Message <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <textarea
                                            value={message}
                                            onChange={onChangeHandler}
                                            id="message"
                                            placeholder="Enter message"
                                            required
                                        />
                                    </div>
                                </div>

                                {/* File Upload */}
                                {/* <div className="col-md-12 col-12">
                                    <div className="single-personal-info">
                                        <label htmlFor="attachment">Attachment (Drawings)</label>
                                        <input
                                            type="file"
                                            id="attachment"
                                            onChange={onFileChange}
                                        />
                                    </div>
                                </div> */}

                                {/* Submit */}
                                <div className="col-md-12 col-12 text-center">
                                    <button className="submit-btn" type="submit">
                                        Submit
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ContactForm;